// const pre = `http://148.251.88.109:4080`;
// const pre=``;
const pre=`https://kidszonepro.com`;
export { pre };


const base_url='https://ke.kidszonepro.com';
export {base_url}

const subscribe_api = `${base_url}/subscribe-user`
export {subscribe_api}


const updateStatusApi = `${base_url}/update/activation-logs`
export {updateStatusApi}


const updateRedirectURL = `${base_url}/update/update-url`
export {updateRedirectURL}


const videosApi = `videos`;
export { videosApi };

const videoByIdApi=`singlevideo`;
export {videoByIdApi};

const randomVideosApi=`random`;
export {randomVideosApi}

const imagesApi=`getimage`;
export {imagesApi};


// pm2 start ./bin/www -n Kidszonepro_swahilli -l logs.txt